import array from './array';

export default array;
